import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DENTAL } from '../../assets/Domains';

export default function PlanSummary({
  currentDomain,
  client,
  onChangePlan,
  onUnsubscribe,
}) {
  let name = '--';
  let description = ['Specify your booking software to see plan options'];

  if (client && Object.keys(client).length) {
    name = client.active_plan_name;
    description = client.active_plan_description;
  }

  return (
    <div className="plan-summary">
      <div className="plan-summary__header">
        <h5>YOUR PLAN</h5>
      </div>
      <div className="plan-summary__content">
        <div className="plan">
          <p className="plan__name">{name}</p>
          {description.map((item, index) => {
            return (
              <p key={`desc-${index + 1}`} className="plan__description">
                {item}
              </p>
            );
          })}
          <p className="plan__next">{client ? client.next_effective_plan : null}</p>
        </div>
      </div>

      {client && client.active_plan && client.active_plan.id ? (
        <div
          className={classnames('plan-summary__actions', {
            hide: true,
          })}
        >
          <button
            type="button"
            className="btn btn--lg btn--primary"
            onClick={onChangePlan}
          >
            Switch Plan
          </button>
          <button
            type="button"
            className="btn btn--link hide"
            onClick={onUnsubscribe}
          >
            Unsubscribe
          </button>
        </div>
      ) : null}
    </div>
  );
}

PlanSummary.defaultProps = {
  onUnsubscribe: () => {},
  onChangePlan: () => {},
  currentDomain: '',
  client: {
    active_plan_name: '',
    active_plan_description: '',
  },
};

PlanSummary.propTypes = {
  onUnsubscribe: PropTypes.func,
  onChangePlan: PropTypes.func,
  currentDomain: PropTypes.string,
  client: PropTypes.shape({}),
};
